import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table, TableBody, TableCell, TableHead, TableRow, Paper
} from "@mui/material";
import { usecdotStore } from "../../components/cdotStore";

const MyShifts = () => {
  const baseURL = process.env.REACT_APP_API_URL;
  const [shifts, setShifts] = useState([]);
  const [myshifts, setMyShifts] = useState([]);
const emp_id = usecdotStore((state) => state.emp_id);
const employees = usecdotStore((state) => state.employees);
  useEffect(() => {
    fetchMyShifts();
    fetchShifts();
  }, []);
  const fetchShifts = async () => {
      try {
        const res = await axios.get(`${baseURL}shifts`);
        setShifts(res.data);
      } catch (error) {
        console.error(error);
      }
    };
  const fetchMyShifts = async () => {
    try {
      const res = await axios.get(`${baseURL}shifts/assign`);
      setMyShifts(res.data);
    } catch (error) {
      console.error(error);
    }
  };
const getEmployeeName = (id) =>
    employees.find((e) => e.id === id)?.emp_name || id;

  const getShiftName = (id) =>
    shifts.find((s) => s.id === id)?.name || id;
  const getShiftType = (id) =>
    shifts.find((s) => s.id === id)?.type || id;
  const getShiftStartTime = (id) =>
    shifts.find((s) => s.id === id)?.start_time || id;
  const getShiftEndTime = (id) =>
    shifts.find((s) => s.id === id)?.end_time || id;

  return (
    <Paper>
      <h2>My Assigned Shifts</h2>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Employee</TableCell>            
            <TableCell>Shift Name</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Time</TableCell>
            <TableCell>Type</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {myshifts.map((s) => (
            <TableRow key={s.id}>
              <TableCell>{getEmployeeName(s.employee_id)}</TableCell>
              
              <TableCell>{getShiftName(s.shift_id)}</TableCell>
              <TableCell>{s.date}</TableCell>
              <TableCell>
                {getShiftStartTime(s.shift_id)} - {getShiftEndTime(s.shift_id)}
              </TableCell>
              <TableCell>{getShiftType(s.shift_id)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default MyShifts;